import Vue from 'vue'
import App from './App.vue'
// import router from './config/router'

// Theme template start
import 'primevue/resources/themes/nova-accent/theme.css' //Tema
import 'primevue/resources/primevue.min.css' //core do Tema 
import 'primeicons/primeicons.css' //Icons
import 'primeflex/primeflex.css'
// end of theme template

import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ColumnGroup from 'primevue/columngroup'
import InputText from 'primevue/inputtext'
import DropDown from 'primevue/dropdown'
import Paginator from 'primevue/paginator'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'

Vue.config.productionTip = false

Vue.component('DataTable', DataTable)
Vue.component('Column', Column)
Vue.component('ColumnGroup', ColumnGroup)
Vue.component('InputText', InputText)
Vue.component('DropDown', DropDown)
Vue.component('Paginator', Paginator)
Vue.component('TabView', TabView)
Vue.component('TabPanel', TabPanel)

new Vue({
  // router,
  render: h => h(App),
}).$mount('#app')
